import { render, staticRenderFns } from "./person_detail.vue?vue&type=template&id=27021c04&scoped=true"
import script from "./person_detail.vue?vue&type=script&lang=js"
export * from "./person_detail.vue?vue&type=script&lang=js"
import style0 from "./person_detail.vue?vue&type=style&index=0&id=27021c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27021c04",
  null
  
)

export default component.exports